module.exports = __webpack_public_path__ + "img/livepen.1899707c.png";